/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { Box, Text } from '@towersystems/towersystems-design-system';
import { map, size, compact, round } from 'lodash';
import { Table } from 'antd';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import { startResourceInfoModal } from 'state/ui/resource-info-modal/actions';
import { startSyncResourceConnectModal } from 'state/ui/sync-resource-connect-modal/actions';
import { startResourceMetaDataModal } from 'state/ui/resource-meta-data-modal/actions';
import Tag from 'components/tag';
import DropdownLink from 'components/dropdown-link';
import { cancelOperation } from 'state/operations/actions';
import { resetResourceConnect } from 'state/resource-connects/actions';
import DateTime from 'components/date-time';

/**
 * Style dependencies
 */
import './styles.scss';

const ResourceListTable = ({ items, requestItems, requesting, ...props }) => {
    const dataSource = map(items, (r) => {
        return r;
    });

    const columns = [
        {
            title: 'Retailer ID',
            key: 'resource_identifier',
            dataIndex: 'resource_identifier',
        },
        {
            title: 'Retailer Name',
            key: 'resource_name',
            dataIndex: 'resource_name',
        },
        {
            title: 'Type',
            key: 'resource_type',
            dataIndex: 'resource_type',
            render: (t) => {
                return t ? <Tag>{t}</Tag> : '-';
            },
        },
        {
            title: 'Required action',
            key: 'action_needed',
            dataIndex: 'action_needed',
            render: (t) => {
                return t ? <Tag warning>{t}</Tag> : '-';
            },
        },
        {
            title: 'Successfully synced',
            key: 'last_synced',
            dataIndex: 'last_synced',
            render: (lastSynced) => {
                return <DateTime date={lastSynced} format='Do MMM, YYYY HH:mm:ss' />;
            },
        },
        {
            title: 'Attempts',
            key: 'number_of_attempts',
            dataIndex: 'number_of_attempts',
        },
        {
            title: 'Error',
            key: 'Errored',
            dataIndex: 'errored',
            render: () => {
                return '-';
            },
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (resourceConnect) => {
                return (
                    <DropdownLink
                        title='Actions'
                        items={compact([
                            {
                                label: 'View data',
                                key: 'view_data',
                                onClick: () => props.startResourceInfoModal(resourceConnect.resource_id),
                            },
                            {
                                label: 'View metadata',
                                key: 'metadata',
                                disabled: !resourceConnect.external_id,
                                onClick: () => props.startResourceMetaDataModal(resourceConnect.id),
                            },
                            {
                                label: 'Sync resource',
                                key: 'sync_resource',
                                onClick: () => props.startSyncResourceConnectModal(resourceConnect.id),
                            },
                            {
                                label: 'Reset',
                                key: 'reset_connection',
                                onClick: async () => {
                                    try {
                                        await props.resetResourceConnect(resourceConnect.id);
                                        requestItems();
                                    } catch ( error ) {
                                        console.log(error);
                                    }
                                },
                            },
                        ])}
                    />
                );
            },
        },
    ];

    return (
        <Box>
            <Table
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                loading={requesting}
                scroll={{ x: 'max-content' }}
            />
        </Box>
    );
};

export default connect(null, {
    startResourceInfoModal,
    startSyncResourceConnectModal,
    startResourceMetaDataModal,
    resetResourceConnect
})(ResourceListTable);
